import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../stores/root';
import { faHome } from '@fortawesome/pro-light-svg-icons';
import PermissionsService from '../../services/permissions';
import NoAccess from '../../components/uiframeworks/noAccess';
import VesselsList from '../../components/vessels/general/list';

interface VesselsListPageProps {
}

const VesselsListPage: React.FC<VesselsListPageProps> = (props: VesselsListPageProps) => {
    const {user, topbar} = useStore();
    const hasPermission = PermissionsService.hasPermission(['vessels.read.all'], user.permissions);
    
    useEffect(() => {
        topbar.show('Vessels', [
            {key: 'home', icon: faHome},
            {key: 'vessels', text: 'Vessels'}
        ]);
    }, []);

    return <Stack>
        {hasPermission ? <VesselsList /> : null}
        {!hasPermission ? <NoAccess /> : null}
    </Stack>;
};

export default VesselsListPage;
